import { render, staticRenderFns } from "./tree-item.vue?vue&type=template&id=f0e7e034&lang=html&"
import script from "./tree-item.vue?vue&type=script&lang=js&"
export * from "./tree-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0e7e034')) {
      api.createRecord('f0e7e034', component.options)
    } else {
      api.reload('f0e7e034', component.options)
    }
    module.hot.accept("./tree-item.vue?vue&type=template&id=f0e7e034&lang=html&", function () {
      api.rerender('f0e7e034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/tree-item.vue"
export default component.exports